import { Box, TableCell, TableRow } from '@mui/material'
import Helper from '../../../helpers/Helper'
import SmartTypography from '../SmartTypography'
import TextLink from '../TextLink'
import { Cell, Column, Row } from './SmartTableDefinitions'

interface P {
    row: Row
    index: number
    item: any
    columns?: Column[]
    onClickRow?: (indexRow: number, row: Row) => void
}

function StandardRow({ row, columns, item, index, onClickRow }: P) {
    const renderContent = (cell: Cell, column: Column) => {
        if (cell.onClick) return <TextLink onClick={cell.onClick}>{cell.value}</TextLink>
        else if (column.customRenderer) return column.customRenderer(cell, row, item)
        else return <SmartTypography charLimit={30}>{(cell.value?.toString())}</SmartTypography>
    }

    return (
        <TableRow
            hover={Helper.hasVal(onClickRow)}
            sx={{ cursor: onClickRow ? 'pointer' : undefined }}
            onClick={() => onClickRow && onClickRow(index, row)}>
            {row.cells.map((x, i) => {
                const column = columns?.at(i)
                if (!column || column.hidden) return null
                return (
                    <TableCell
                        key={i}
                        sx={{ padding: 1, paddingLeft: 4, WebkitFilter: column.blur ? 'blur(5px)' : '' }}
                        align={column?.numeric ? 'right' : 'left'}>
                        <Box minHeight={34} display='flex' alignItems='center'>
                            {renderContent(x, column)}
                        </Box>
                    </TableCell>
                )
            })}
        </TableRow>
    )
}

export default StandardRow
